import React, { forwardRef, KeyboardEventHandler, useContext, useEffect, useRef } from 'react';
import { IDefaultComponentProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import { DialogContext } from '../context';
import { IUnitChildProps } from '@src/core/Unit/models';

import styled from './DialogContainer.scss';
import { AnyType } from '@src/models/common';
import { DATA_ELEM_CONTAINER } from '../const';

interface IProps extends IDefaultComponentProps, IUnitChildProps {
  disableCloseOnEscapeKeyDown?: boolean;
}

export const DialogContainer = forwardRef<HTMLDivElement, IProps>(
  ({ children, className, onVisible, disableCloseOnEscapeKeyDown, ...rest }, ref) => {
    const { isMobile, onClose } = useContext(DialogContext);
    const classes = classnames(styled.root, className, {
      [styled.rootMobile]: isMobile,
    });
    const prevFocused = useRef<Element | null>(null);

    const handleKeyUp: KeyboardEventHandler = (e) => {
      if (e.key === 'Escape' && !disableCloseOnEscapeKeyDown) {
        e.stopPropagation();
        onClose?.();
      }
    };

    /**
     * Так как роддительский элемент контейнера не <Box />,
     * а <div /> поэтому реализовываем эвент показа для юнита
     */
    useEffect(() => {
      onVisible?.();
    }, [onVisible]);

    useEffect(() => {
      prevFocused.current = document.activeElement;
      (ref as AnyType)?.current?.focus();

      return () => {
        if (prevFocused.current) (prevFocused.current as AnyType).focus();
      };
    }, [ref]);

    return (
      <div tabIndex={0} ref={ref} className={classes} onKeyUp={handleKeyUp} {...rest} data-elem={DATA_ELEM_CONTAINER}>
        {children}
      </div>
    );
  },
);

DialogContainer.displayName = 'DialogContainer';
